import styled, { css } from 'styled-components';
import { fontBody } from 'Styles/fonts';
import breakpoint from 'Styles/breakpoints';

import StickyBarOriginal from '../StickyBar/StickyBar';
import BreadcrumbsOriginal from '../ContentSystem/components/Breadcrumbs/Breadcrumbs';
import ResponsiveImageGalleryOriginal from './components/ResponsiveImageGallery/ResponsiveImageGallery';

import ProductDetailsOriginal from './components/ProductDetails/ProductDetailsContainer';
import { StyledSpan } from '../LinkText/LinkText.styled';

export const Breadcrumbs = styled(BreadcrumbsOriginal)`
  z-index: 1;

  ${({ $styleQueryMode }) => `
    justify-content: center;

      ${StyledSpan} {
        ${fontBody(14)}
      }

      ${breakpoint('medium', { mode: $styleQueryMode })} {
        justify-content: flex-start;
        
        ${StyledSpan} {
          ${fontBody(16)}
        }
      }
    `}
`;

export const ProductImageContainer = styled.div``;
export const ProductDetailsContainer = styled.div`
  padding: 0 16px 24px;
`;

export const ProductDetails = styled(ProductDetailsOriginal)`
  ${({ $styleQueryMode }) => css`
    width: 100%;
    ${breakpoint('medium', { mode: $styleQueryMode })} {
      padding-bottom: 0;
    }
  `}
`;

export const ProductDetailsInner = styled.div`
  width: 100%;

  & > ${Breadcrumbs} {
    display: flex;
  }
`;

export const StickyBar = styled(StickyBarOriginal)`
  padding: 0;
  width: 100%;
  ${breakpoint('medium')} {
    grid-column: span 12;
  }

  ${breakpoint('large')} {
    grid-column: span 5;
    display: flex;
    justify-content: center;
    max-width: 424px;
  }

  ${breakpoint('largest')} {
    justify-content: start;
  }
`;

// container query logic
export const ResponsiveImageGallery = styled(ResponsiveImageGalleryOriginal)`
  ${breakpoint('medium')} {
    padding-top: 48px;
    position: sticky;
    /**
     * no navbar in modal in container mode
     */
    top: ${({ $styleQueryMode }) =>
    $styleQueryMode === 'container' ? 0 : '64px'};
  }

  ${breakpoint('large')} {
    padding: 24px 0;
    padding-top: ${({ $styleQueryMode }) =>
    $styleQueryMode === 'container' && '64px;'};
  }

  ${breakpoint('largest')} {
    ${({ $styleQueryMode }) =>
    $styleQueryMode === 'screen' &&
    css`
        width: 65vw;
        top: 0;
      `}
  }
`;

export const Product = styled.section`
  ${({ $styleQueryMode }) => css`
    position: relative;
    max-width: 1520px;
    margin: 0 auto;

    ${breakpoint('medium', { mode: $styleQueryMode })} {
      display: flex;
      column-gap: 32px;
      padding: 0 48px;

      ${ProductImageContainer} {
        width: 100%;
      }

      ${ProductDetailsContainer} {
        padding: 24px 0;
        min-width: 384px;
      }
    }

    ${breakpoint('large', { mode: $styleQueryMode })} {
      display: grid;
      grid-template-columns: repeat(12, minmax(0px, 89.34px));
      column-gap: 32px;
      padding-right: 0;

      ${ProductImageContainer} {
        grid-column: 6 / span 7;
      }

      ${ProductDetailsContainer} {
        grid-row: 1;
        grid-column: 1 / span 5;
        justify-self: center;
        max-width: 424px;
      }
    }

    ${breakpoint('largest', { mode: $styleQueryMode })} {
      ${ProductImageContainer} {
        grid-column: 5 / span 8;
      }

      ${ProductDetailsContainer} {
        grid-column: 1 / span 4;
        justify-self: left;
        align-self: start;
      }
    }
  `}
`;
